// extracted by mini-css-extract-plugin
export default {"input":"styles_input__1Inqn","selectInput":"styles_selectInput__qsO4s"};